export default {
  //用户登录
  code: '',
  login: '',
  userInfo: '',
  userInfoInquire: '',
  userEdit: {},
  teaMessageList: '',
  centreMessageList: '',
  courseMessageList: '',
  baseMessageList: '',
  courseList: '',
  jxtalkList: '',
  baseEvaluationList: '',
  baseEvaluationDel: '',
  userThirdpartyLogin:'',
  userLoginScore:'',
  userListGather:'',
  third: {},
  userPasswordVerify:'',
  userPasswordSecurity:''
}



// WEBPACK FOOTER //
// ./src/store/user/states.js